<template>
    <PopoverRight ref="popoverContent" width="500px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">新增内容项</h1>
            <p class="remark">1、动态取值字段请用<span class="red">[标签名]</span>表示，如<span class="red">[城市]</span> 在长沙站生成导购文章内展示为：长沙，广州站生成导购文章内展示为：广州。</p>
            <p class="remark">2、支持动态取值的字段名称及取值示范，可点击<span @click="showTagLib" style="color:rgb(0 85 245);cursor: pointer;">“动态取值标签库”</span>  进行查看。</p>
            <el-form class="form-container" :model="formList" ref="contentValidateForm">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">文章类型</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item >
                            <el-select v-model="formList.type" placeholder="全部">
                                <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id" ></el-option>
                            </el-select>                        
                        </el-form-item>
                    </div>
                </div>
                 <div class="form-item">
                    <div class="form-label">
                        <span class="label">内容项</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item >
                            <el-select v-model="formList.body_type" placeholder="全部" @change="changeType">
                                    <el-option v-for="item in bodyType" :key="item.id" :label="item.name" :value="item.id" ></el-option>
                                </el-select>                   
                        </el-form-item>
                    </div>
                </div>
                <template v-if="formList.body_type == 1">
                    <el-card class="box-card"  v-for="(target, key) in formList.title" :key="key">
                        <i class="el-icon-close" @click.prevent="removeContent(target)"></i>
                        <div class="form-item">
                            <div class="form-label">
                                <span class="label">标题</span>
                                <label class="warn">*</label>
                            </div>
                            <div class="form-input-item">
                                <el-form-item 
                                    :prop="'title.' + key + '.body'" 
                                    :rules="titleRule"
                                >
                                    <el-input placeholder="[城市][楼盘名称]好不好？" class="input-control" v-model="target.body"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                    </el-card>
                </template>
                <template v-if="formList.body_type == 2">
                    <el-card class="box-card"  v-for="(target, key1) in cntTags" :key="key1">
                        <i class="el-icon-close" @click.prevent="removeContent(target)"></i>
                        <div class="form-item">
                            <div class="form-label">
                                <span class="label">关键字</span>
                                <label class="warn">*</label>
                            </div>
                            <div class="form-input-item">
                               <el-form-item>
                                     <el-tag
                                        class="topic-tag"
                                        v-model="target[index]"
                                        v-for="(tag,index) in target"
                                        :key="index"
                                        closable
                                        :disable-transitions="false"
                                        @close="handleClose(tag,key1)"
                                        >{{ tag }}</el-tag
                                    >
                                    <template v-if="cntTags[key1].length < 4" >
                                            <el-input
                                            class="input-new-tag"
                                            v-if="inputVisible == 'inputVisible' + key1"
                                            v-model="inputValue"
                                            :ref="`saveTagInput${key1}`"
                                            size="small"
                                            @keyup.enter.native="handleInputConfirm(key1)"
                                            @blur="handleInputConfirm(key1)"
                                            >
                                            </el-input>
                                            <el-button
                                            v-else
                                            class="button-new-tag"
                                            size="small"
                                            @click="showInput(key1)"
                                        >+ 添加关键字</el-button
                                        >
                                    </template>
                                </el-form-item>
                            </div>
                        </div>
                    </el-card>
                </template>
                 <template v-if="formList.body_type == 3">
                    <el-card class="box-card"  v-for="(target, key) in formList.body" :key="key">
                        <i class="el-icon-close" @click.prevent="removeContent(target)"></i>
                        <div class="form-item">
                            <div class="form-label">
                                <span class="label">正文</span>
                                <label class="warn">*</label>
                            </div>
                            <div class="form-input-item">
                                <el-form-item 
                                    :prop="'body.' + key + '.body'" 
                                    :rules="bodyRule"
                                >
                                    <el-input type="textarea" minlength="1" maxlength="1000" placeholder="请输入正文内容" class="input-control" v-model="target.body"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                    </el-card>
                </template>
                <div class="align-center">
                    <el-button @click="hideMenu">取消</el-button>
                    <el-button @click="addContent">新增选项</el-button>
                    <el-button type="primary" @click="submitForm('contentValidateForm')" v-if=" formList.body_type == 2 && cntTags.length > 0 && cntTags[0] !=''">提交</el-button>
                    <el-button type="primary" @click="submitForm('contentValidateForm')" v-if=" formList.body_type == 1 && formList.title.length > 0 && formList.title[0].body != ''">提交</el-button>
                    <el-button type="primary" @click="submitForm('contentValidateForm')" v-if=" formList.body_type == 3 && formList.body.length > 0 && formList.body[0].body != ''">提交</el-button>

                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>
<script>
import PopoverRight from '@/components/popoverRight/index'
import { NEWS_MODEL } from "@/config/index";
import {NewsCntAdd,getCntDetail} from '@/service/newsModel'

export default {
    name: 'add',
    components: {
        PopoverRight,
    },
    props: {
        callback: Function,
        size: Number
    },
    data () {
      
        return {
            typeList:[],
            bodyType:[],
            cntTags:[
                []
            ],
            typeKey:"title",
            typeName:"标题",
            formList: {
                type:1,
                body_type:1,
                title: [
                    {
                        body:""
                    }
                ],
                body:[
                    {
                        body:""
                    }
                ]

            },
            inputVisible: '',
            inputValue: "",
            isClear: false,
            titleRule: [
                { required: true, message: '标题不能为空', trigger: 'blur' },
                { min: 1, max: 50, message: '标题为1-50个字符之间', trigger: 'blur' },
            ],
            bodyRule: [
                { required: true, message: '正文不能为空', trigger: 'blur' },
                { min: 1, max: 1000, message: '正文为1-1000个字符之间', trigger: 'blur' },
            ],
            index: null
        }
    },
    mounted(){
        this.typeList = NEWS_MODEL.news_types;
        this.bodyType = NEWS_MODEL.body_type;
    },
    methods: {
        /** 打开右侧悬浮层 */
        openMenu () {
            this.$refs.popoverContent && this.$refs.popoverContent.open()
        },
        /** 关闭右侧悬浮层 */
        hideMenu () {
            this.resetForm()
            this.$refs.popoverContent && this.$refs.popoverContent.hide()
            this.$refs.contentValidateForm && this.$refs.contentValidateForm.clearValidate()
        },
        
        handleClose(tag,index) {
        this.cntTags[index].splice(this.cntTags[index].indexOf(tag), 1);
        },
        showInput(index) {
            this.inputVisible =`inputVisible${index}`;
            this.$nextTick((_) => {
                this.$refs[`saveTagInput${index}`][0].$refs.input.focus;
            });
        },
        handleInputConfirm(index) {
        let inputValue = this.inputValue;
        if (inputValue && inputValue.length <= 10) {
            this.cntTags[index].push(inputValue);
            
            this.inputVisible =`inputVisible${index}`;
            this.inputValue = "";
        } else if (inputValue == "") {
            this.inputVisible =`inputVisible${index}`;;
            this.inputValue = "";
        } else {
            this.$message({
            type: "error",
            message: "关键词最多10个字符",
            });
            return false;
        }
        },
        changeType(val){
             this.$refs.contentValidateForm && this.$refs.contentValidateForm.clearValidate()
            if(val == 1){
                this.typeKey = "title";
                this.typeName = "标题";
            }else if(val == 2){
                this.typeKey = "title";
                this.typeName = "关键词";
            }else{
                this.typeKey = "body";
                this.typeName = "正文";
            }
        },
        showTagLib(){
            this.$emit("showTagLib")
        },
        resetForm () {
            this.formList = {
              type:1,
                body_type:1,
                title: [
                    {
                        body:""
                    }
                ],
                body:[
                    {
                        body:""
                    }
                ]
            }
            this.cntTags=[[]];
            this.index= null;
            this.typeKey = "title";
            this.typeName = "标题";
        },
        addContent () {
            if(this.formList.body_type == 2){
                 if (10 === this.cntTags.length) {
                    this.$message({
                        type: 'error',
                        message: '最多只能绑定10组'+this.typeName
                    })
                    return null
                }
                this.cntTags.push([]);
            }else{
                if (10 === this.formList[this.typeKey].length) {
                    this.$message({
                        type: 'error',
                        message: '最多只能绑定10个'+this.typeName
                    })
                    return null
                }
                this.formList[this.typeKey].push({
                    body:'',
                    key: Date.now(),
                    isAdd: true,
                });
            }
           
        },
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) return null
                const query={};
                if(this.formList.body_type == 2){
                    let arr=[];
                    var tagsArr = this.cntTags.filter(item => item.length != 0);
                    if(!tagsArr.length){
                        this.$message({
                            type: "error",
                            message: "关键词不能为空",
                        });
                        return;
                    }
                    tagsArr.forEach((el)=>{
                        let obj={};
                        el = el.join(",")
                        obj.body = el;
                        obj.type = this.formList.type;
                        obj.body_type = this.formList.body_type;
                        arr.push(obj)
                    })
                    query.data = arr;
                }else{
                    // 判断当前是否有重复的数据
                    const index = this.formList[this.typeKey].findIndex((v, v1) => {
                        const k = this.formList[this.typeKey].findIndex((a, a1) => {
                            return a.body === v.body && a1 !== v1
                        })
                        return k >= 0
                    })
                    if (index >= 0) {
                        this.$message({
                            type: 'error',
                            message: '不能添加重复的'+this.typeName
                        })
                        return null
                    }
                    this.formList[this.typeKey].forEach((el)=>{
                        el.type = this.formList.type;
                        el.body_type = this.formList.body_type;
                    })
                    query.data = this.formList[this.typeKey];
                }
                NewsCntAdd(query).then((data) => {
                   this.$message({
                        type: "success",
                        message: "新增"+this.typeName+"成功",
                    });
                    this.hideMenu();
                    this.callback && this.callback()

                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: err.message || "新增失败",
                    });
                });

            })
        },
         removeContent(item) {
            if(this.formList.body_type == 2){
                const index = this.cntTags.indexOf(item)
                if (index !== -1) {
                    this.cntTags.splice(index, 1)
                }
            }else{
                const index = this.formList[this.typeKey].indexOf(item)
                if (index !== -1) {
                this.formList[this.typeKey].splice(index, 1)
                }
            }
           
        }
    }
}
</script>
<style scoped>
.form-input-item .el-tag /deep/ .el-icon-close {
  display: inline-block !important;
  border-radius: 50%;
  text-align: center;
  position: relative !important;
  cursor: pointer;
  font-size: 12px !important;
  height: 16px !important;
  width: 16px !important;
  line-height: 16px !important;
  vertical-align: middle;
  top: -1px !important;
  right: -5px !important;

}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: auto;
  margin-left: 10px;
  vertical-align: bottom;
}
.remark{
    font-size: 14px;
    padding-top: 10px;
    line-height:30px;
    color: #666;
}
.red{
    color:red;
}
</style>